import * as React from 'react';
import { Component } from 'react';
import { FormGroup, FormControl } from 'react-bootstrap';
import { PhysiotherapistService } from '../../services/PhysiotherapistService';
import { LoaderComponent } from '../../controls/Loader';
import { DEFAULT_STATUS_TIMEOUT } from '../../constants/SystemConsts';
import { ShowStatusBar } from '../Layout/GlobalStatusBar';

interface IProps {
    IsEditMode: boolean,
    AboutMe?: string,
    OnRefreshRequired: () => void
}

interface IState {
    EditAboutMe: boolean,
    AboutMeInputValue: string,
    ShowAll: boolean,
    LoaderVisible: boolean
}

export class AboutMeComponent extends Component<IProps, IState> {
    constructor(props) {
        super(props);

        this.state = {
            EditAboutMe: false,
            AboutMeInputValue: this.props.AboutMe ? this.props.AboutMe : '',
            ShowAll: false,
            LoaderVisible: false
        }

        this.OnAboutMeSubmit = this.OnAboutMeSubmit.bind(this);
        this.OnAboutMeAbort = this.OnAboutMeAbort.bind(this);
        this.OnEditAboutMeClick = this.OnEditAboutMeClick.bind(this);
        this.OnUpdateSuccess = this.OnUpdateSuccess.bind(this);
        this.OnUpdateError = this.OnUpdateError.bind(this);
        this.OnInputChange = this.OnInputChange.bind(this);
        this.ShowMore = this.ShowMore.bind(this);
        this.ShowLess = this.ShowLess.bind(this);
    }

    public componentWillReceiveProps(nextProps: IProps) {
        this.setState({
            LoaderVisible: false
        });
    }

    public render() {
        let inputSection: null | JSX.Element = null;
        let buttons: null | JSX.Element = null;
        if (this.state.EditAboutMe) {
            if (this.props.IsEditMode) {
                buttons = (
                    <div className="buttons">
                        <button className="std-secondary-btn" onClick={this.OnAboutMeAbort}>Anuluj</button>
                        <button type="submit" className="std-primary-btn">Zapisz</button>
                    </div>
                );
            }
            inputSection = (
                <div className="input">
                    <form onSubmit={this.OnAboutMeSubmit}>
                        <FormGroup>
                            <FormControl
                                componentClass={"textarea"}
                                name="AboutMeInputValue"
                                type="text" rows={5} onChange={this.OnInputChange}
                                value={this.state.AboutMeInputValue}
                                placeholder="Przedstaw się jako fizjoterapeuta - daj się poznać przyszłym pacjentom!" />
                        </FormGroup>
                        {buttons}
                    </form>
                </div>
            );
        } else {
            if (this.props.IsEditMode) {
                buttons = (
                    <div className="buttons">
                        <a onClick={this.OnEditAboutMeClick}>Edytuj</a>
                    </div>
                );
            }
            let aboutMe = '';
            let showMoreButton: null | JSX.Element = null;
            if (this.props.AboutMe) {
                const numberOfWords = 35;
                if (this.props.AboutMe.split(" ").length > numberOfWords) {
                    if (this.state.ShowAll) {
                        aboutMe = this.props.AboutMe;
                        showMoreButton = (
                            <a className="show-more-btn" onClick={this.ShowLess}>zobacz&nbsp;mniej</a>
                        );
                    } else {
                        aboutMe = this.props.AboutMe.split(" ").slice(0, numberOfWords).join(" ");
                        showMoreButton = (
                            <a className="show-more-btn" onClick={this.ShowMore}>zobacz&nbsp;więcej</a>
                        );
                    }
                } else {
                    aboutMe = this.props.AboutMe;
                }
            }
            inputSection = (
                <div className="input">
                    <LoaderComponent Visible={this.state.LoaderVisible} />
                    {
                        (aboutMe !== null && aboutMe !== undefined && aboutMe !== '') ?
                            <span className="about-description">{aboutMe}{showMoreButton}</span> :
                            null
                    }
                    {buttons}
                </div>
            );
        }

        return (
            <div className="form-row">
                <label>O mnie:</label>
                {inputSection}
            </div>
        );
        
    }//end-of-render


    private OnInputChange(event) {
        let partialState = {};
        partialState[event.target.name] = event.target.value;
        this.setState(partialState);
    }

    private OnAboutMeAbort(evt) {
        this.setState({
            EditAboutMe: false
        });
    }

    private OnAboutMeSubmit(evt) {
        let service = new PhysiotherapistService();
        service.UpdateAboutMe(this.state.AboutMeInputValue, this.OnUpdateSuccess, this.OnUpdateError);
        this.setState({
            EditAboutMe: false,
            LoaderVisible: true
        });
        evt.preventDefault();
    }

    private OnUpdateSuccess(result) {
        this.props.OnRefreshRequired();
        ShowStatusBar('Success', 'Zaktulizowano sekcję "o mnie"', DEFAULT_STATUS_TIMEOUT);
    }

    private OnUpdateError(error) {
        this.setState({
            LoaderVisible: false
        });
        console.error(error);
        ShowStatusBar('Error', 'Nie udało się zaktualizować sekcji "o mnie". Spróbuj ponownie.', DEFAULT_STATUS_TIMEOUT);
    }

    private OnEditAboutMeClick(evt) {
        this.setState({
            EditAboutMe: true,
            AboutMeInputValue: this.props.AboutMe ? this.props.AboutMe : ''
        });
    }

    private ShowMore(evt) {
        this.setState({
            ShowAll: true
        });
    }

    private ShowLess(evt) {
        this.setState({
            ShowAll: false
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/PhysiotherapistView/AboutMe.tsx